import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=75b31f66&scoped=true&v-slot%3Aitems=props&"
import script from "./BlogArticle.vue?vue&type=script&lang=js&"
export * from "./BlogArticle.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=75b31f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b31f66",
  null
  
)

export default component.exports